const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/portfolio/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { getItemsTreeSetQueryOptions } from 'src/lib/queries/common/useGetItemsDataSetQuery';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio/')({
  loader: async ({
    params: {
      loopId
    },
    context: {
      queryClient
    }
  }) => {
    const filter = {
      loopId: {
        value: Number(loopId),
        operator: 'eq' as const
      }
    };
    await queryClient.ensureQueryData(getItemsTreeSetQueryOptions({
      filter
    }));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});